module.exports = __webpack_public_path__ + "static/media/top_catch@2x.d6b11b89.png";